<div
  *ngFor="let item of fileList"
  class="file-container d-flex flex-column mt-0 me-0 mb-3 ms-0 p-3 border border-primary rounded-2 h-auto"
  [ngClass]="{ 'text-primary': !item?.error, 'border border-danger rounded': item?.error }"
>
  <div class="icon-status-wrapper d-flex">
    <div data-test-selector="name-icon-container" class="name-icon-container d-flex flex-grow-2 align-items-center">
      <i class="fa-2xl" [ngClass]="(item | fileTypeIcon) || ''"></i>
      <span title="{{ item.name }}" class="filename align-self-center ps-3 overflow-hidden">
        <a
          *ngIf="downloadAllowed"
          [href]="item.url"
          onclick="event.stopPropagation()"
          >{{ item.name }}</a
        >
        {{ downloadAllowed ? '' : item.name }}
      </span>
    </div>

    <div
      data-test-selector="file-status-container"
      class="file-status-container"
    >
      <div *ngIf="item.isLoading; then loading; else doneLoading"></div>

      <ng-template #loading>
        <div
          *appLoadingIndicator="{
            show: item.isLoading,
            showBackdrop: false,
            fullPage: false,
            message: 'Loading'
          }"
        ></div>
      </ng-template>

      <ng-template
        #doneLoading
        [ngSwitch]="!!item.error && item.errors?.length !== undefined"
      >
        <div *ngSwitchCase="true">
          <i
            class="fas fa-exclamation-triangle"
            [ngClass]="{ 'text-danger' : true }"
          ></i>
          <span>{{ item.error }}</span>
        </div>

        <div *ngSwitchCase="false">
          <div class="status">
            <i class="fas fa-check" [ngClass]="{ 'text-success' : true }"></i>
            <span>Ready</span>
          </div>
          <div *ngIf="deleteAllowed">
            <span>
              <button
                type="button"
                class="btn"
                (click)="onDelete($event, item.id)"
              >
                <i class="fa fa-times" aria-hidden="true"></i>
              </button>
            </span>
          </div>
        </div>
      </ng-template>
    </div>

    <ul *ngIf="item.errors">
      <li *ngFor="let error of item.errors">
        <div>{{ error }}</div>
      </li>
    </ul>
  </div>
</div>
